<div class="filter-form-container">
  <div class="filters" *ngIf="filters.length > 0">
    <button mat-raised-button class="filter-buttons" (click)="onAddFilter()">Add Filter</button>
    <div *ngFor="let filterGroup of filters.controls; let i = index" [formGroup]="filterGroup">
      <app-group-filter
        [form]="filterGroup"
        [groupInterface]="groupInterface">
      </app-group-filter>
      <button mat-raised-button (click)="onRemoveFilter(i)">Remove</button>
    </div>
  </div>
  
  <div class="filters" *ngIf="filters.length === 0">
    <button mat-raised-button class="filter-buttons" (click)="onAddFilter()">Add Filter</button>
  </div>
</div>
